import React from 'react';
import { ConnectionStatus as ConnectionStatusType } from '../types';
import { useProcessing } from '../context';

interface ConnectionStatusProps {
  status: ConnectionStatusType;
  error?: string | null;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ status, error }) => {
  const { state: processingState } = useProcessing();
  if (!processingState.isProcessing) {
    return null;
  }

  const getStatusMessage = () => {
    switch (status) {
      case 'connecting':
        return 'Connecting...';
      case 'connected':
        return 'Connected';
      case 'reconnecting':
        return 'Reconnecting...';
      case 'error':
        return error || 'Connection error';
      case 'disconnected':
        return 'Disconnected';
      default:
        return '';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'connecting':
        return '🔄';
      case 'connected':
        return '🟢';
      case 'reconnecting':
        return '🔄';
      case 'error':
        return '⚠️';
      case 'disconnected':
        return '⭕';
      default:
        return '';
    }
  };

  const getStatusClass = () => {
    return `connection-status ${status}`;
  };

  return (
    <div className={getStatusClass()}>
      <span className="status-icon">{getStatusIcon()}</span>
      <span className="status-message">{getStatusMessage()}</span>
    </div>
  );
};

export default ConnectionStatus; 